import { render, staticRenderFns } from "./user-request-apporve-popup.html?vue&type=template&id=50fe20a6&scoped=true&external"
import script from "./user-request-apporve-popup.js?vue&type=script&lang=js&external"
export * from "./user-request-apporve-popup.js?vue&type=script&lang=js&external"
import style0 from "./user-request-apporve-popup.scss?vue&type=style&index=0&id=50fe20a6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe20a6",
  null
  
)

export default component.exports